module.exports = __webpack_public_path__ + "img/loader.d07dd55.svg";